<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

        <config-title-hang>
          <span slot="config_title_hang_ele2">所有的控制对象</span>
          <input slot="config_title_hang_ele8" type="text" placeholder="快速搜索" v-model="scerchValue" />
        </config-title-hang>

        <!-- 服务器返回的根据按键控制类型返回的设备列表 -->
        <config-hang v-for="(value, index) in serveControlObjectListData" :key="index"
          @click.native="selectObjectBtnHandle(value)"
          :selectState="value.businessId === selectObjectInfo.businessId1 || value.businessId === selectObjectInfo.businessId2">

          <!-- // 代号 20250207-2 -->
          <!-- 设备名称 -->
          <span slot="config_hang_ele2_1">{{ value.businessName }}</span>
          <!-- 只显示有效字段，确保 | 只在有效字段之间 -->
          <span slot="config_hang_ele2_2">{{ getFormattedString(value) }}</span>
          <span v-if="selectSceneStateText(value) !== ''" slot="config_hang_ele3">
            {{ selectSceneStateText(value) }}
          </span>
          <img slot="config_hang_weixuan" src="~assets/img/config/weixuan.png" alt />
          <img slot="config_hang_xuanzhong" src="~assets/img/config/xuanzhong.png" alt />

        </config-hang>

        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
import { mediumslateblue } from "color-name";
import { serace03ControlData } from "common/tool";
export default {
  data() {
    return {
      serveControlObjectListData: [
        ///服务器返回的控制设备数据
      ],
      serveControlObjectListDataBack: [
        //搜索使用
      ],
      scerchValue: "", // 搜索使用
      ServeOneObjectinfo: {
        ////一个对象的信息
      },
      selectButton: {
        buttonCode: "",
        buttonId: "",
        buttonName: "",
      }, ////选中的ID
      noBusinessInfo: {
        ////虚拟的一个不绑定任何对象的可选信息
        businessId: "0",
        businessName: "不绑定任何对象",
        businessState: 0,
        regionId: "",
        regionName: "无",
      },
      selectObjectInfo: {
        ////已经选中的绑定信息
        businessId1: "",
        businessId1Desc: "",
        businessId2: "",
        businessId2Desc: "",
      }
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang,
  },

  methods: {
    getFormattedString(value) {
      if (!value) return "";
      // console.log(value);
      const { regionName, uniqueCode16, gatewayName } = value;
      console.log(uniqueCode16);

      // 过滤掉 `null` 和 `""` 的字段
      const validFields = [regionName, uniqueCode16, gatewayName].filter(item => item !== null && item !== "" && item !== undefined);

      // 只有当存在有效字段时，才返回拼接后的字符串，否则返回空
      return validFields.length > 0 ? validFields.join("|") : "";
    },
    selectSceneStateText(value) {
      if (this.ServeOneObjectinfo.buttonCode !== "2" || value.businessId === "0") {
        return "";
      }
      if (value.businessId === this.selectObjectInfo.businessId1) {
        return "开状态场景";
      }
      if (value.businessId === this.selectObjectInfo.businessId2) {
        return "关状态场景";
      }
      return "";
    },
    selectObjectBtnHandle(value) {
      // console.log('111111')
      // 触发类型	BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"),  	BUTTON_03("3", "通断"), BUTTON_04("4", "调光"),  	BUTTON_05("5", "电机")

      if (this.ServeOneObjectinfo.buttonCode === "2") {
        ///说明是双场景,最多选两个  这一块牵扯的逻辑较多，不宜修改
        console.log("2222");
        if (value.businessId === "0") {
          if (
            this.selectObjectInfo.businessId1 === "0" ||
            this.selectObjectInfo.businessId2 === "0"
          ) {
            this.selectObjectInfo.businessId2 = "";
            this.selectObjectInfo.businessId1 = "";
          } else {
            this.selectObjectInfo.businessId2 = value.businessId;
            this.selectObjectInfo.businessId1 = value.businessId;
          }
          this.selectObjectInfo.businessId1Desc = value.businessName;
          this.selectObjectInfo.businessId2Desc = "";
          console.log(this.selectObjectInfo.businessId1);
          console.log(this.selectObjectInfo.businessId2);
          return;
        }
        if (
          this.selectObjectInfo.businessId1 === value.businessId ||
          this.selectObjectInfo.businessId2 === value.businessId
        ) {
          if (this.selectObjectInfo.businessId1 === value.businessId) {
            this.selectObjectInfo.businessId1 = "";
            this.selectObjectInfo.businessId1Desc = "";
            // this.selectObjectInfo.businessId2Desc = value.businessName
          } else if (this.selectObjectInfo.businessId2 === value.businessId) {
            this.selectObjectInfo.businessId2 = "";
            this.selectObjectInfo.businessId2Desc = "";
          }
          console.log(this.selectObjectInfo.businessId1);
          console.log(this.selectObjectInfo.businessId2);
          return;
        }
        if (value.businessId != "0") {
          if (
            this.selectObjectInfo.businessId1 === "" ||
            this.selectObjectInfo.businessId2 === ""
          ) {
            if (this.selectObjectInfo.businessId1 === "") {
              this.selectObjectInfo.businessId1 = value.businessId;
              this.selectObjectInfo.businessId1Desc = value.businessName;
              // this.selectObjectInfo.businessId2Desc = value.businessName
            } else if (this.selectObjectInfo.businessId2 === "") {
              this.selectObjectInfo.businessId2 = value.businessId;
              // this.selectObjectInfo.businessId1Desc = value.businessName
              this.selectObjectInfo.businessId2Desc = value.businessName;
            }
          } else if (
            this.selectObjectInfo.businessId1 != "" ||
            this.selectObjectInfo.businessId2 != ""
          ) {
            if (
              this.selectObjectInfo.businessId1 === "0" ||
              this.selectObjectInfo.businessId2 === "0"
            ) {
              this.selectObjectInfo.businessId1 = value.businessId;
              this.selectObjectInfo.businessId1Desc = value.businessName;
              this.selectObjectInfo.businessId2 = "";
              this.selectObjectInfo.businessId2Desc = "";

              // if (this.selectObjectInfo.businessId1 === '0') {
              //   this.selectObjectInfo.businessId1 = value.businessId
              //   this.selectObjectInfo.businessId2 = ''
              // } else if (this.selectObjectInfo.businessId2 === '0') {
              //   this.selectObjectInfo.businessId2 = value.businessId
              //   this.selectObjectInfo.businessId1 = ''
              // }
            } else {
              this.selectObjectInfo.businessId2 = value.businessId;
              this.selectObjectInfo.businessId2Desc = value.businessName;
            }
            // if (this.selectObjectInfo.businessId1 === '') {
            //   this.selectObjectInfo.businessId1 = value.businessId
            // } else if (this.selectObjectInfo.businessId2 === '') {
            //   this.selectObjectInfo.businessId2 = value.businessId
            // }
          }
        }
      } else {
        this.selectObjectInfo.businessId1 = value.businessId;
        this.selectObjectInfo.businessId1Desc = value.businessName;
      }
      console.log(this.selectObjectInfo.businessId1);
      console.log(this.selectObjectInfo.businessId2);

      // this.selectButton.buttonId = value.buttonId
      // this.selectButton.buttonCode = value.buttonCode
      // this.selectButton.buttonName = value.buttonName
    },
    saveReturnBtnHandle() {
      ///保存并返回按钮点击了
      if (this.ServeOneObjectinfo.buttonCode === "2") {
        //说明是双场景
        if (
          this.selectObjectInfo.businessId1 === "" ||
          this.selectObjectInfo.businessId2 === ""
        ) {
          this.$toast("请至少选择两个场景或选择不绑定！");
          return;
        }
      } else {
        if (this.selectObjectInfo.businessId1 === "") {
          this.$toast("请至少选择一个控制对象！");
          return;
        }
      }
      ////提交选中的信息并返回
      this.ServeOneObjectinfo.businessId1 = this.selectObjectInfo.businessId1;
      this.ServeOneObjectinfo.businessId1Desc = this.selectObjectInfo.businessId1Desc;

      this.ServeOneObjectinfo.businessId2 = this.selectObjectInfo.businessId2;
      this.ServeOneObjectinfo.businessId2Desc = this.selectObjectInfo.businessId2Desc;

      // this.ServeOneObjectinfo.buttonName = this.selectButton.buttonName
      this.$router.go(-1);
    },
    //业内数据搜索显示  //搜索使用
    seraceDataShow(charData) {
      if (
        this.serveControlObjectListData &&
        this.serveControlObjectListDataBack
      ) {
        //数据是合法存在的
        this.serveControlObjectListData = this.serveControlObjectListData.concat(
          this.serveControlObjectListDataBack
        );
        this.serveControlObjectListDataBack.length = 0;
        if (charData.match(/^[ ]*$/)) {
          //说明为空 或多个空
        } else {
          let dataLength = this.serveControlObjectListData.length;
          for (let i = 0; i < dataLength; i++) {
            // 代号 20250207-2
            if (
              (
                this.serveControlObjectListData[i].businessName +
                this.serveControlObjectListData[i].regionName +
                this.serveControlObjectListData[i].uniqueCode16 +
                this.serveControlObjectListData[i].gatewayName
              ).indexOf(charData) == -1
            ) {
              // && this.serveControlObjectListData[i].checked == false
              // 说明没有这个字符
              this.serveControlObjectListDataBack.push(
                this.serveControlObjectListData[i]
              );
              this.serveControlObjectListData.splice(i, 1);
              dataLength--;
              i--;
            }
          }
        }
        console.log(this.serveControlObjectListData);
      }
    }
  },
  watch: {
    scerchValue: function (val) {
      console.log("发生变化" + val);
      this.seraceDataShow(val); //新增页内搜索
    },
  },
  created() {
    console.log("created阶段");
    this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo; ////一个对象的地址信息拿过来

    ////补服务端BUG，服务端在只绑定了一个设备时，返回了第二个对象的值businessId2是0，所以会勾选不绑定帮任何设备的  选项。这里判断处理一下
    if (this.ServeOneObjectinfo.buttonCode != "2") {
      ///不是双场景，只有一个设备需要绑定，第二个值就没用了，给它传空,或者不传。默认是空。
      this.selectObjectInfo.businessId1 = this.ServeOneObjectinfo.businessId1;
      this.selectObjectInfo.businessId1Desc = this.ServeOneObjectinfo.businessId1Desc;
    } else {
      ////拿到选中的信息  是双场景
      console.log(this.selectObjectInfo);
      this.selectObjectInfo.businessId1 = this.ServeOneObjectinfo.businessId1;
      this.selectObjectInfo.businessId1Desc = this.ServeOneObjectinfo.businessId1Desc;

      this.selectObjectInfo.businessId2 = this.ServeOneObjectinfo.businessId2;
      this.selectObjectInfo.businessId2Desc = this.ServeOneObjectinfo.businessId2Desc;
    }

    ///获取触发设备接口，获取数据
    this.$request({
      method: "post",
      url: "/device/findTriggerDeviceByButtonCode",
      data: {
        token: this.$store.state.token,
        buttonCode: this.ServeOneObjectinfo.buttonCode,
        gatewayId: this.ServeOneObjectinfo.gatewayId,
      },
    })
      .then((res) => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveControlObjectListData = res.data.data; ////拿到服务器返回的数据结果
          this.serveControlObjectListData.unshift(this.noBusinessInfo); ///添加一个不绑定任何设备的可选对象信息
          // console.log(this.serveControlObjectListData);
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch((error) => {
        console.log(error);
      });

    ////拿到已经选中的信息
    // this.selectButton.buttonCode = this.ServeOneObjectinfo.buttonCode
    // this.selectButton.buttonId = this.ServeOneObjectinfo.buttonId
    // this.selectButton.buttonName = this.ServeOneObjectinfo.buttonName
  },
};
</script>

<style></style>
